import { render, staticRenderFns } from "./addksInfo.vue?vue&type=template&id=62048986&"
import script from "./addksInfo.vue?vue&type=script&lang=js&"
export * from "./addksInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports